export default __webpack_public_path__ + "static/media/P20.778d2957.svg";